<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <!--                <v-btn @click="$router.push('/content')" class="btn-back">-->
                <!--                  <span class="flaticon2-reply icon-lg"></span>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <v-spacer/>-->
                <!--                افزودن محتوا-->
                <!--                <v-spacer/>-->
                <v-btn @click="addContent" class="submit-btn">
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-text-field
                      :rules="rules.title"
                      v-model="title"
                      autofocus
                      :error-messages="errors.title"
                      label="عنوان"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-select
                      v-model="service"
                      :rules="rules.service"
                      :items="services"
                      :error-messages="errors.service"
                      item-text="nameLand"
                      item-value="id"
                      label="انتخاب سرویس"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-select
                      v-model="type"
                      :rules="rules.type"
                      :items="types"
                      item-text="value"
                      item-value="name"
                      label="نوع محتوا"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <!--                                <v-row class="flex-column align-items-center" v-if="category_id">-->
                    <!--                                    <v-radio-group row v-model="privilege_type">-->
                    <!--                                        <v-radio label="ادمین" color="primary" value="admin"></v-radio>-->
                    <!--                                        <v-radio label="کاربر" color="primary" value="user"></v-radio>-->
                    <!--                                    </v-radio-group>-->

                    <v-row>
                      <v-card-title>معرفی پروژه:</v-card-title>
                      <v-radio-group row v-model="intro">
                        <v-radio label="بله" value="1"></v-radio>
                        <v-radio label="خیر" value="0"></v-radio>
                      </v-radio-group>
                    </v-row>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field v-model="link" label="پیوند" outlined dense>
                    </v-text-field>
                  </v-flex>
                  <!--                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">-->
                  <!--                                        <v-text-field-->
                  <!--                                            v-model="sortOrder"-->
                  <!--                                            :error-messages="errors.sort_order"-->
                  <!--                                            label="اولویت نمایش"-->
                  <!--                                            outlined-->
                  <!--                                            dense-->
                  <!--                                        >-->
                  <!--                                        </v-text-field>-->
                  <!--                                    </v-flex>-->
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-file-input
                      v-model="picture"
                      label="تصویر محتوا"
                      :error-messages="errors.picture"
                      outlined
                      dense
                      prepend-icon="mdi-camera"
                    ></v-file-input>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-autocomplete
                      label="انتخاب دسته بندی"
                      dense
                      append-icon="mdi-menu"
                      editable
                      auto-select-first
                      outlined
                      :error-messages="errors !== [] ? errors.category_id : ''"
                      v-model="category_id"
                      :items="categories"
                    />
                  </v-flex>
                </v-row>

                <!--                                <v-row class="flex-column align-items-center" v-if="category_id">-->
                <!--                                    <v-radio-group row v-model="privilege_type">-->
                <!--                                        <v-radio label="ادمین" color="primary" value="admin"></v-radio>-->
                <!--                                        <v-radio label="کاربر" color="primary" value="user"></v-radio>-->
                <!--                                    </v-radio-group>-->

                <!--                                </v-row>-->
                <div class="row my-10">
                  <v-row>
                    <v-container fluid>
                      <!--                    <ckeditor :editor="editor.editor" v-model="description"-->
                      <!--                              :config="editor.editorConfig">-->

                      <!--                    </ckeditor>-->
                      <v-col>
                        <!--                      <v-card-title v-html="description"></v-card-title>-->

                        <V8Editor v-model="description" />
                      </v-col>
                    </v-container>
                  </v-row>
                </div>
                <v-row v-if="type == 'tutorial'">
                  <v-text-field
                    v-model="adminTitle"
                    autofocus
                    :error-messages="errors.title"
                    label="عنوان آموزش ادمین"
                    required
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-container fluid>
                    <label>متن اموزش ادمین</label>

                    <V8Editor v-model="adminDescription" />
                  </v-container>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-container fluid>
                    <label>متن اموزش بخش ویژگی ها</label>
                    <V8Editor v-model="features" />
                  </v-container>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-card elevation="0" color="transparent" class="mb-4">
                      <v-card-title>سوالات متداول</v-card-title>

                      <v-card
                        v-for="(x, i) in value"
                        :key="i"
                        outlined
                        class="mb-4"
                      >
                        <v-card-title>
                          <v-chip outlined color="#009688">
                            سوال {{ i + 1 }}
                          </v-chip>

                          <v-spacer />
                          <v-btn
                            x-small
                            fab
                            elevation="0"
                            color="error"
                            @click="deleteKeyValue(x, i)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-card-title>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="12" lg="12" class="pt-0">
                            <v-text-field
                              label="سوال"
                              v-model="x.question"
                              outlined
                              id="propKey"
                            />
                          </v-col>
                        </v-row>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="12" lg="12" class="pt-0">
                            <V8Editor v-model="x.answer" />

                            <!--                            <v-textarea label="پاسخ" v-model="x.answer" outlined-->
                            <!--                                        id="propValue"/>-->
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card-actions class="pa-0 my-4">
                        <v-btn block color="accent" @click="newKeyValue">
                          <v-icon>mdi-plus</v-icon>
                          افزودن سوال و پاسخ جدید
                        </v-btn>
                      </v-card-actions>

                      <v-divider />
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Editor from "@ckeditor/ckeditor5-vue2";
import CKEditorUploadAdapterPlugin from "../../../core/plugins/CKEditorUploadFileAdapter";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  props: ["id"],
  data() {
    return {
      value: [],
      editor: {
        editor: Editor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      service: null,
      type: null,
      intro: "0",
      services: [],
      permissions: [],
      categories: [],
      privilege_type: null,
      category_id: null,
      permissionIds: [],
      query: { sort: "id", order: "desc", limit: 100, s: "" },
      rules: {
        title: [(val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد"],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد"],
        type: [(val) => !!val || "فیلد نوع محتوا الزامی می باشد"],
      },
      types: [
        { name: "popup", value: "پاپ اپ" },
        { name: "tutorial", value: "آموزش" },
        { name: "news", value: "اخبار" },
        { name: "banner", value: "بنر" },
      ],
      title: "",
      adminTitle: "",
      adminDescription: "",
      features: "",
      description: "",
      picture: null,
      link: "",
      sortOrder: "",
      errors: [],
      secondContent: {},
    };
  },

  async mounted() {
    // let brokenString="[{\"question\":\"سلام سوال؟\",\"answer\":\"سلام پاسخ\"}]"
    // const replaced = brokenString.replaceAll('\\', '-');
    // console.log;

    // this.keydown('addContent')
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService().data
    this.getCategories();
  },
  methods: {
    newKeyValue() {
      this.value.push({
        question: "",
        answer: "",
      });
    },
    deleteKeyValue(x, i) {
      if (confirm("سوال و جواب حذف شود ؟")) {
        this.value.splice(this.value.indexOf(i), 1);
      }
    },
    getCategories() {
      this.loading = true;

      this.requestApiGet("category/get-all", { permission: true })
        .then(({ data }) => {
          let category = [];
          for (let i = 0; i < data.length; i++) {
            category.push({
              text:
                data[i].name + " \t" + "( " + data[i].service.nameLand + " )",
              value: data[i].id,
            });
          }
          this.categories = category;
          this.loading = false;
        })
        .catch(({ response }) =>
          console.log("error in get provinces: ", response)
        );
    },
    addContent() {
      if (this.service == null) {
        return this.$toast.error("لطفا سرویس را انتخاب کنید.");
      }
      if (this.type == null) {
        return this.$toast.error("لطفا نوع محتوا را انتخاب کنید.");
      }
      let formData = new FormData();
      formData.append("service_id", this.service);
      formData.append("type", this.type);
      formData.append("title", this.title);
      formData.append("intro", this.intro);
      formData.append("description", this.description);
      if (this.category_id) {
        formData.append("category_id", this.category_id);
      }
      if (this.privilege_type) {
        formData.append("privilege_type", this.privilege_type);
      }
      if (this.features) {
        formData.append("features", this.features);
      }

      if (this.adminTitle && this.adminDescription) {
        formData.append("adminTitle", this.adminTitle);
        formData.append("adminDescription", this.adminDescription);
      }

      if (this.value) {
        let questionValue = JSON.stringify(this.value);
        formData.append("commonQuestions", questionValue);
      }

      if (this.picture !== null) formData.append("picture", this.picture);
      formData.append("link", this.link);
      this.requestApiPost(`content`, formData, this.configurationFile())
        .then((response) => {
          this.$toast.success("محتوا با موفقیت اضافه شد.");
          this.goReplace("content");
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        });
    },
  },
};
</script>

<style scoped>
#questionEditor {
  height: 10rem;
}
</style>
